import { fetchFromAPI } from 'utils/api';

export function fetchCompanies() {
  return fetchFromAPI('/companies', { params: { per_page: 1000 } }).then((response) => response.resources);
}

export function searchCompanies(params) {
  return fetchFromAPI('/companies/search', { params });
}
